export enum CrownAction {
  add = 'add',
  configure = 'configure',
}
